import React, { useCallback } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { IProfile } from '../../types/policy-profile-types';
import { useSnapshot } from 'valtio';
import ProfileStore from '../../store/profiles';
import { changeProfileInContext } from '../../actions/policies-profile-actions/change-profile-in-context-action';
import {
  setChangeProfileInContextId,
  setShowUnSavedProfileChangesModal,
} from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';
import PoliciesProfileUIStateStore from '../../store/policies-profile-ui';

interface ProfileSelectBoxProps {
  profileIdInContext: string;
}

const ProfileSelectBox: React.FC<
  React.PropsWithChildren<ProfileSelectBoxProps>
> = ({ profileIdInContext }: ProfileSelectBoxProps) => {
  const { profiles, activeProfileId } = useSnapshot(ProfileStore);
  const { disableSavePoliciesButton } = useSnapshot(
    PoliciesProfileUIStateStore,
  );

  const handleChange = useCallback(
    (e: SelectChangeEvent<string>) => {
      if (disableSavePoliciesButton) {
        changeProfileInContext(e.target.value);
        return;
      }
      setChangeProfileInContextId(e.target.value);
      setShowUnSavedProfileChangesModal(true);
    },
    [disableSavePoliciesButton],
  );

  return (
    <Box minWidth={267}>
      <FormControl size='small' fullWidth>
        <InputLabel shrink variant='standard' htmlFor='profile-select-box'>
          <Typography color='text.primary' variant='body2'>
            Select Profile:
          </Typography>
        </InputLabel>
        <Select
          fullWidth
          color='primary'
          variant='standard'
          size='small'
          value={profileIdInContext}
          name='profile-select-box'
          label='Select Profile:'
          onChange={handleChange}>
          {profiles.map((p: IProfile) => (
            <MenuItem key={p.profileId} value={p.profileId}>
              <Stack
                flexGrow={1}
                direction='row'
                alignItems='center'
                justifyContent='space-between'
                sx={{ lineHeight: 10 }}>
                <Typography flexGrow={1} variant='subtitle1'>
                  {p.profileName}
                </Typography>
                {p.profileId === activeProfileId && (
                  <Typography
                    sx={{ fontStyle: 'Italic', fontWeight: 'medium' }}
                    variant='body2'>
                    active
                  </Typography>
                )}
              </Stack>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ProfileSelectBox;
